"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin } from "lucide-react";
import { useEffect, useState } from "react";
export default function LocationMap() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: overlayRef,
    isVisible: overlayVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const [pinDropped, setPinDropped] = useState(false);
  useEffect(() => {
    if (sectionVisible) {
      const timer = setTimeout(() => {
        setPinDropped(true);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [sectionVisible]);
  return <section ref={sectionRef} className={`relative w-full h-[600px] overflow-hidden transition-opacity duration-[var(--duration-slow)] ${sectionVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute inset-0 bg-muted-light-background">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24446.22737467889!2d-86.14607!3d39.978371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8814ad7e0f6e8c8f%3A0x7f7f7f7f7f7f7f7f!2sCarmel%2C%20IN!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Texas Margaritas Location Map" className="w-full h-full" />
      </div>

      {}
      <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 pointer-events-none z-10 transition-all duration-[600ms] ease-[var(--ease-spring)] ${pinDropped ? "-translate-y-1/2 opacity-100" : "-translate-y-[150%] opacity-0"}`} style={{
      animation: pinDropped ? "bounce-drop 0.6s ease-out" : "none"
    }}>
        <MapPin className="w-12 h-12 text-primary drop-shadow-strong" />
      </div>

      {}
      <div ref={overlayRef} className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-[90%] max-w-md mb-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${overlayVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="bg-background/90 backdrop-blur-md rounded-lg shadow-strong border border-border p-6 hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <MapPin className="w-6 h-6 text-primary" />
            </div>
            <div className="flex-1 space-y-3">
              <div>
                <h3 className="font-display font-semibold text-foreground text-lg mb-1">
                  Visit Us
                </h3>
                <p className="text-muted-foreground text-sm">
                  Carmel, Indiana
                </p>
              </div>
              <div>
                <h4 className="font-display font-semibold text-foreground text-base mb-1">
                  Hours
                </h4>
                <div className="text-muted-foreground text-sm space-y-0.5">
                  <p>Mon–Thu: 11am–10pm</p>
                  <p>Fri–Sat: 11am–10:30pm</p>
                  <p>Sun: 11am–9pm</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes bounce-drop {
          0% {
            transform: translate(-50%, -150%);
            opacity: 0;
          }
          50% {
            transform: translate(-50%, -40%);
            opacity: 1;
          }
          65% {
            transform: translate(-50%, -55%);
          }
          80% {
            transform: translate(-50%, -48%);
          }
          100% {
            transform: translate(-50%, -50%);
            opacity: 1;
          }
        }
      `}</style>
    </section>;
}